<template>
<v-form ref="formSelect">
  <v-select
      v-model="item"
      :items="items"
      :label="itemAction.name"
      :item-text="itemText"
      item-value="id"
      clearable
      multiple
      outlined
      dense>
        <!--
          <template v-slot:selection="{item}"> {{itemText(item)}} </template>
        -->
        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
              <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
              <v-list-item-content v-if="item.padre_id == 0">
                <span class="font-weight-bold subtitle-2">{{itemText(item)}}</span>
              </v-list-item-content>
              <v-list-item-content v-else class="pl-3" v-text="itemText(item)" />
          </v-list-item>
        </template>
  </v-select>
</v-form>

</template>

<script>
import axios from 'axios'
export default {
  props: ['itemAction', 'onSuccess', 'showItems'],
  data: () => ({
    item: [],
    items: []
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    getDinamicData (url) {
      if (url !== '') {
        const token = this.$cookies.get('token_sirh')
        axios.post(url, {}, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
          this.items = []
          if (this.itemAction.sub) {
            this.items = this.SubItems(response.data)
          } else {
            this.items.push(...response.data)
          }
        }).catch(error => {
          if (error == null) {}
        })
      } else {
        if (this.itemAction.sub) {
          this.items = this.SubItems(this.itemAction.items)
        } else {
          this.items.push(...this.itemAction.items)
        }
      }
    },
    itemText (item) {
      if (item && (this.itemAction.nameid === 'ejercicio_id' || this.itemAction.nameid === 'ejercicio_anteriores_id')) {
        return `${item.descripcion}`
      } else if (item && (this.itemAction.nameid === 'categoria_id' || this.itemAction.nameid === 'departamento_id')) {
        return `${item.nombre}`
      } else if (item && this.itemAction.nameid === 'tipo_plaza_id') {
        return `${item.nombre} - ${item.tipo_regimen}`
      }
      return 'No Title'
    },
    SubItems (its) {
      const items = []
      its.map(item => {
        if (item.padre_id === 0) {
          items.push(item)
          if (item[this.itemAction.sub].length > 0) {
            item[this.itemAction.sub].map(sub => {
              items.push(sub)
            })
          }
        }
      })
      return items
    }
  },
  computed: {
  },
  watch: {
    item (val) {
      if (val) {
        this.onSuccess({ id: this.itemAction.nameid, data: val })
      } else {
        this.onSuccess(val)
      }
    },
    showItems (vals) {
      if (this.itemAction.sub) {
        this.items = this.SubItems(vals)
      } else {
        this.items.push(...vals)
      }
    }
  }
}
</script>

<style>

</style>
